export default {
  name: 'marking--returnP',
  apiService: 'shoes',
  apiPath: '/admin/return_p',
};